import "./ToTop.css";

const ToTop = () => {
    const back = () => {
        document.documentElement.scrollTo({
            top:0,
            behavior: "smooth"
        });
    };
    return (<button onClick={back} className="totop" href="#home">
        ⬆️
    </button>)
}

export default ToTop;